import { cn } from '@/utils/classnames';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-fx-neutral-200 animate-pulse rounded-md', className)}
      {...props}
    />
  );
}

export { Skeleton };
